import React, { useState, useEffect } from 'react';
import { Form, Input, Button, Icon, Select, Tooltip, Radio, Divider, Alert, DatePicker, Checkbox } from 'antd';
import { QuickTransfer, Beneficiary } from '../../../../models';
import { MerchantService } from '../../../../services';
import { handleApiExceptions, alertify, printRupee, isVirtualAccountVisible } from '../../../../app_methods';
import { connect } from 'react-redux';
import { PAYMENT_METHODS, PROVIDER_PAYMENT_MODE_MESSAGES } from '../../../../constants';
import { getBankLogo } from '../../../../constants';
import { Text4 } from '../../../../styles';
import moment from 'moment';
import './index.scss';
import { beneficiaryOrganisationTypes as organisationTypes } from "../../../../constants";


let QuickTransferForm = (props) => {
    const [disabledFields, setDisabledFields] = useState({
        "NEFT": false,
        "RTGS": true,
        "IMPS": false,
        "UPI": false,
        "AMAZON_WALLET": false
    });
    const [isGenerating, setIsGenerating] = useState(false);
    const [isVerifying, setIsVerifying] = useState(false);
    const [showAdvancedOptions, setShowAdvancedOptions] = useState(false);
    const [selectedVirtualAccount, setSelectedVirtualAccount] = useState(props.current_user.virtual_account);
    const [amount, setAmount] = useState();

    const { form } = props;
    const { getFieldDecorator } = form;
    const validations = QuickTransfer.validations;
    const techSpec = selectedVirtualAccount?.settings?.provider_technical_spec || {};
    const yesbank_ftx_gaming = !!techSpec?.yesbank_ftx_gaming
    const isPowerAxis = !!techSpec?.power_axis;
    const isBeneLEIVisible = amount > 500000000 && isPowerAxis
    const isFtx = !!techSpec?.yesbank_ftx


    const generateUniqueRequestNumber = () => {
        setIsGenerating(true);
        MerchantService.generate_urn().then(response => {
            if (response.success) form.setFieldsValue({ "unique_request_number": response.data.unique_request_number })
            setIsGenerating(false);
        }).catch(error => {
            setIsGenerating(false);
            handleApiExceptions(error);
        })
    };

    const verifyUPIHandle = () => {
        if (!form.getFieldValue("upi_handle")) return;
        setIsVerifying(true);
        Beneficiary.verify_vpa({ vpa: form.getFieldValue("upi_handle") }).then(response => {
            setIsVerifying(false);
            if (response.success) {
                let beneficiary_name = "";
                if (response.data.status == "valid") beneficiary_name = response.data.account_holder_name;
                else if (["invalid", "failure"].includes(response.data.status)) alertify("Oops!", "Entered UPI Handle is invalid.", "error");
                form.setFieldsValue({ "beneficiary_name": beneficiary_name });
            }
            else {
                alertify("Oops!", response.message || "Something went wrong.", "error");
            }
        }).catch(error => {
            setIsVerifying(false);
            handleApiExceptions(error);
        })
    };

    const verifyBankAccount = () => {
        if (!form.getFieldValue("account_number") || !form.getFieldValue("ifsc")) return;
        setIsVerifying(true);
        Beneficiary.verify_bank_account({
            account_no: form.getFieldValue("account_number"),
            ifsc: form.getFieldValue("ifsc")
        }).then(response => {
            setIsVerifying(false);
            if (response.success) {
                let beneficiary_name = "";
                if (response.data.status != "valid") handleApiExceptions("Bank account details are invalid.");
                else beneficiary_name = response.data.account_holder_name;
                form.setFieldsValue({ "beneficiary_name": beneficiary_name });
            }
            else {
                alertify("Oops!", response.message || "Something went wrong.", "error");
            }
        }).catch(error => {
            setIsVerifying(false);
            handleApiExceptions(error);
        })
    };

    const handleAmountChange = (e) => {
        const amount = parseFloat(e.target.value);
        if (isNaN(amount)) return;
        setAmount(amount);
        let _disabledFields = { ...disabledFields };
        _disabledFields["UPI"] = amount < 1 || amount > 100000;
        _disabledFields["NEFT"] = amount < 1;
        _disabledFields["RTGS"] = amount < 200000;
        _disabledFields["IMPS"] = amount < 1 || amount > 500000;
        _disabledFields["AMAZON_WALLET"] = amount < 1 || amount > 100000;
        setDisabledFields(_disabledFields);
        if (props.form.getFieldValue("payment_mode") == "RTGS" && amount <= 500000) props.form.setFieldsValue({ payment_mode: "IMPS" });
        else if (props.form.getFieldValue("payment_mode") == "IMPS" && amount > 500000) props.form.setFieldsValue({ payment_mode: "RTGS" });
    };

    const onSubmit = (e) => {
        e.preventDefault();
        let amount = parseFloat(form.getFieldValue('amount'))
        if (isNaN(amount)) amount = 0;

        if (amount < 0) {
            alertify("Error!", "Minium amount of 1 is required", "error");
            return
        }
        form.validateFields((err, values) => {
            if (err) return;
            let payment_mode = form.getFieldValue("payment_mode")
            if (values.beneficiary_type === "amazon_wallet") {
                const updatedUpiHandle = `${values.upi_handle}@amazonpay`;
                form.setFieldsValue({ upi_handle: updatedUpiHandle });
            }
            let txn_limit = props.current_user.tl;
            if (payment_mode in txn_limit && txn_limit[payment_mode] && form.getFieldValue('amount') > txn_limit[payment_mode]) {
                alertify("Oops!", `Amount exceeds transaction limit of Rs. ${parseFloat(txn_limit[payment_mode]).toFixed(2)} for ${payment_mode}.`, "error");
                return;
            }
            props.onSubmit(form.getFieldsValue());
            form.setFieldsValue({
                upi_handle: values.upi_handle.replace("@amazonpay", ""),
            });
        });
    };

    const renderBankAccountDetailsForm = () => {
        return (
            <>
                <div className="row">
                    <div className="col-sm-12 col-md-6 col-lg-6">
                        <Form.Item className="mb-0" label="Account Number">
                            {getFieldDecorator("account_number", {
                                rules: validations.account_number
                            })(<Input autoComplete='off' prefix={<Icon type="bank" />} />)}
                        </Form.Item>
                    </div>
                    <div className="col-sm-12 col-md-6 col-lg-6">
                        <Form.Item className="mb-0" label="Account IFSC Code">
                            {getFieldDecorator("ifsc", {
                                rules: validations.ifsc,
                                normalize: (value) => value && value.toUpperCase()
                            })(<Input autoComplete='off' prefix={<Icon type="bank" />} />)}
                        </Form.Item>
                    </div>
                </div>
                {
                    props.current_user.ebav ?
                        <>
                            <div className="mt-1 d-flex justify-content-end">
                                <Button className="px-0" type="link" onClick={verifyBankAccount} loading={isVerifying}>Verify Bank Account</Button>
                            </div>
                            <Divider style={{ marginTop: 10, marginBottom: 10, background: "#dddddd" }} />
                        </> : null
                }
            </>
        )
    };

    const renderVAExtra = () => {
        return (
            props.current_user.euv ?
                <Button type="link" size="small" loading={isVerifying} onClick={verifyUPIHandle}>Verify</Button> : null
        )
    };

    const renderUpiDetailsForm = () => {
        return (
            <div className="row">
                <div className="col-sm-12 col-md-12 col-lg-12">
                    <Form.Item label="UPI Handle">
                        {getFieldDecorator("upi_handle", {
                            rules: validations.upi_handle
                        })(<Input autoComplete='off' prefix={<Icon type="qrcode" />} addonAfter={renderVAExtra()} />)}
                    </Form.Item>
                </div>
            </div>

        )
    };

    const renderAmazonWalletForm = () => {
        return (
            <div className="row">
                <div className="col-sm-12 col-md-12 col-lg-12">
                    <Form.Item label="Amazon Wallet">
                        {getFieldDecorator("upi_handle", {
                            rules: validations.phone,
                            initialValue: form.getFieldValue("upi_handle")
                                ? form.getFieldValue("upi_handle").replace("@amazonpay", "")
                                : ""
                        })(<Input
                            autoComplete='off'
                            prefix={<Icon type="amazon" />}
                            addonAfter="@amazonpay"
                            placeholder="Enter mobile number"
                        />)}
                    </Form.Item>
                </div>
            </div>

        )
    };

    const renderURNExtra = () => {
        return (
            <Tooltip title="Generate Random">
                <Icon type="setting" spin={isGenerating} onClick={generateUniqueRequestNumber} />
            </Tooltip>
        )
    };

    let merchant_payment_modes = [];
    PAYMENT_METHODS.forEach(payment_method => {
        if (props.current_user.payment_modes.includes(payment_method.value)) {
            merchant_payment_modes.push(payment_method.value)
        }
    });

    const beneficiaryType = form.getFieldValue("beneficiary_type");
    const paymentModeOptions = beneficiaryType === "upi"
        ? ["UPI"]
        : beneficiaryType === "amazon_wallet"
            ? ["AMAZON_WALLET"]
            : merchant_payment_modes.filter(mode => mode !== "UPI" && mode !== "AMAZON_WALLET");




    function range(start, end) {
        const result = [];
        for (let i = start; i < end; i++) {
            result.push(i);
        }
        return result;
    }

    function disabledDate(current) {
        // Can not select days before today and today
        return current && current < moment().endOf('day');
    }
    
    useEffect(() => {
        form.setFieldsValue({ "payment_mode": paymentModeOptions[0] });
    }, [form.getFieldValue("beneficiary_type")]);   

    const showPaymentMode = ["upi", "amazon_wallet"].includes(form.getFieldValue("beneficiary_type"));

    const handleVirtualAccountChange = (value) => {
        const selectedVA = props.current_user.virtual_accounts.find(
            (va) => va.virtual_account_number === value
          );
        setSelectedVirtualAccount(selectedVA);
    }

    return (
        <Form className="quick-transfer-form-wrapper" onSubmit={onSubmit}>
            <div className="mb-4">
                {getFieldDecorator("queue_on_low_balance", {
                    initialValue: props.current_user.eqlb
                })(<Input autoComplete='off' hidden />)}
                {getFieldDecorator("beneficiary_type", {
                    initialValue: merchant_payment_modes.includes("UPI")
                        ? "upi"
                        : merchant_payment_modes.includes("AMAZON_WALLET")
                            ? "amazon_wallet"
                            : "bank_account",
                    rules: validations.beneficiary_type,
                })(
                    <Radio.Group>
                        {
                            merchant_payment_modes.some(m => ["IMPS", "NEFT", "RTGS"].includes(m)) ?
                                <Radio.Button value="bank_account">Bank Account</Radio.Button> : null
                        }
                        {
                            merchant_payment_modes.includes("UPI") ?
                                <Radio.Button value="upi">UPI Handle</Radio.Button> : null
                        }
                        {
                            merchant_payment_modes.includes("AMAZON_WALLET") ?
                                <Radio.Button value="amazon_wallet">Amazon Wallet</Radio.Button> : null
                        }
                    </Radio.Group>
                )}
            </div>

            {form.getFieldValue("beneficiary_type") === "bank_account"
                ? renderBankAccountDetailsForm()
                : form.getFieldValue("beneficiary_type") === "upi"
                    ? renderUpiDetailsForm()
                    : form.getFieldValue("beneficiary_type") === "amazon_wallet"
                        ? renderAmazonWalletForm()
                        : null}


            <div className="row">
                <div className="col-sm-12 col-md-6 col-lg-6">
                    <Form.Item label="Beneficiary Name">
                        {getFieldDecorator("beneficiary_name", {
                            rules: validations.beneficiary_name
                        })(<Input autoComplete='off' prefix={<Icon type="user" />} />)}
                    </Form.Item>
                </div>
                <div className="col-sm-12 col-md-6 col-lg-6">
                    {!props?.current_user?.enable_custom_irn_for_tr ?
                        <Form.Item label="Unique Request Number">
                            {getFieldDecorator("unique_request_number", {
                                rules: validations.unique_request_number
                            })(<Input autoComplete='off' prefix={<Icon type="audit" />} addonAfter={renderURNExtra()} />)}
                        </Form.Item> :
                        <Form.Item label="Unique Request Number">
                            {getFieldDecorator("unique_request_number", {
                                rules: validations.custom_unique_request_number
                            })(<Input autoComplete='off' prefix={<Icon type="audit" />} addonAfter={renderURNExtra()} />)}
                        </Form.Item>
                    }
                </div>
            </div>

            <div className="row">
                <div className="col-sm-12 col-md-6 col-lg-6">
                    <Form.Item label="Amount">
                        {getFieldDecorator("amount", {
                            rules: validations.amount
                        })(<Input autoComplete='off' prefix={<span dangerouslySetInnerHTML={{ __html: `&#8377; ` }} />} onChange={handleAmountChange} />)}
                    </Form.Item>
                </div>
                {<div className="col-sm-12 col-md-6 col-lg-6">
                    {!showPaymentMode ? <Form.Item label="Payment Mode">
                        {getFieldDecorator("payment_mode", {
                            initialValue: paymentModeOptions[0],
                            rules: validations.payment_mode,
                        })(
                            <Select disabled={["upi", "amazon_wallet"].includes(form.getFieldValue("beneficiary_type"))}>
                                {
                                    paymentModeOptions.map(mode =>
                                        <Select.Option value={mode} disabled={disabledFields[mode]}>{mode}</Select.Option>
                                    )
                                }
                            </Select>
                        )}
                    </Form.Item> :
                        <Form.Item>
                            {getFieldDecorator("payment_mode", {
                                initialValue: paymentModeOptions[0],
                                rules: validations.payment_mode,
                            })(
                                <Input type='hidden' />
                            )}
                        </Form.Item>
                    }
                </div>}


            </div>

            {
                PROVIDER_PAYMENT_MODE_MESSAGES[props.current_user.virtual_account.provider_code]
                    &&
                    PROVIDER_PAYMENT_MODE_MESSAGES[props.current_user.virtual_account.provider_code][form.getFieldValue('payment_mode')]
                    ?
                    <Alert
                        className="mb-2"
                        type="info"
                        message={PROVIDER_PAYMENT_MODE_MESSAGES[props.current_user.virtual_account.provider_code][form.getFieldValue('payment_mode')].node}
                        icon={<Icon type="info-circle" />}
                        showIcon
                    /> : null
            }

            <Form.Item label="Source Virtual Account">
                {getFieldDecorator("virtual_account_number", {
                    rules: QuickTransfer.validations.virtual_account_number,
                    initialValue: isVirtualAccountVisible(props.current_user.virtual_account) && props.current_user.virtual_account.virtual_account_number 
                })(<Select optionLabelProp="label" onChange={handleVirtualAccountChange}>
                    {
                        props.current_user.virtual_accounts.filter(va => va.status == "active" && isVirtualAccountVisible(va)).map((va, index) => {
                            const label = (
                                <span style={{ display: "flex", alignItems: "center" }}>
                                  <img
                                    alt=""
                                    src={getBankLogo(va.provider_code)}
                                    style={{
                                        height: 20,
                                        width: 20,
                                        objectFit: "contain",
                                        marginRight: 8,
                                    }}
                                />
                                  <Text4 type="secondary"> {va.label} - Available Balance: {printRupee(va.balance, 3)}</Text4>
                                </span>
                              );
                            return (
                                <Select.Option label={label} value={va.virtual_account_number} disabled={va.funding_via == 2 && !props.current_user.allow_payouts_via_cc_va ? true : false}>
                                    <div className="d-flex align-items-start">
                                        <div
                                            style={{
                                                display: "flex",
                                                width: 28,
                                                overflow: "hidden",
                                                textAlign: "center",
                                                marginRight: 8,
                                                marginTop: 5
                                            }}
                                        >
                                            <img
                                                style={{
                                                    margin: "auto",
                                                    width: "auto",
                                                    maxWidth: "100%",
                                                    maxHeight: 28
                                                }}
                                                alt=""
                                                src={getBankLogo(va.provider_code)}
                                            />
                                        </div>
                                        <div className="d-flex flex-column">
                                            <Text4 className="mr-1">{va.label} {va.label_name ? `(${va.label_name})` : null}</Text4>
                                            <Text4 type="secondary">Available Balance: {printRupee(va.balance, 3)}</Text4>
                                        </div>
                                    </div>
                                </Select.Option>
                            )
                        })
                    }
                </Select>)}
            </Form.Item>

            <Divider style={{ marginTop: 10, marginBottom: 10, background: "#dddddd" }} />

            <div className="row">
                <div className="col-sm-12 col-md-6 col-lg-6">
                    <Form.Item autoComplete='off' label="Beneficiary Email">
                        {getFieldDecorator("email", {
                            rules: validations.email
                        })(<Input autoComplete='off' prefix={<Icon type="email" />} />)}
                    </Form.Item>
                </div>
                <div className="col-sm-12 col-md-6 col-lg-6">
                    <Form.Item autoComplete='off' label="Beneficiary Phone">
                        {getFieldDecorator("phone", {
                            rules: validations.phone
                        })(<Input autoComplete='off' prefix={<Icon type="phone" />} />)}
                    </Form.Item>
                </div>
            </div>

            <div className="row">
                <div className="col-sm-12 col-md-6 col-lg-6">
                    <Form.Item autoComplete='off' label="Narration">
                        {getFieldDecorator("narration", {
                            rules: validations.narration
                        })(<Input autoComplete='off' prefix={<Icon type="edit" />} />)}
                    </Form.Item>
                </div>
                <div className="col-sm-12 col-md-6 col-lg-6">
                    <Form.Item autoComplete='off' label="Schedule for later">
                        {getFieldDecorator("scheduled_for", {
                            rules: validations.scheduled_for
                        })(
                            <DatePicker
                                style={{ width: "100%" }}
                                format="YYYY-MM-DD"
                                disabledDate={disabledDate}
                            />
                        )}
                    </Form.Item>
                </div>
            </div>
            <div className="row">
                {yesbank_ftx_gaming && <div className="col-sm-12 col-md-6 col-lg-6">
                    <Form.Item autoComplete="off" label="User ID">
                        {getFieldDecorator("beneficiary_user_id", {
                            rules: validations.beneficiary_user_id,
                        })(<Input autoComplete="off" prefix={<Icon type="user" />} />)}
                    </Form.Item>
                </div>}
                {(yesbank_ftx_gaming || isPowerAxis || isFtx) && <div className="col-sm-12 col-md-6 col-lg-6">
                    <Form.Item autoComplete="off" label="PAN Number">
                        {getFieldDecorator("pan_number", {
                            rules: validations.pan_number,
                            normalize: (value) => value && value.toUpperCase(),
                        })(<Input autoComplete="off" prefix={<Icon type="idcard" />} />)}
                    </Form.Item>
                </div>}
                {isBeneLEIVisible && <div className="col-sm-12 col-md-6 col-lg-6">
                    <Form.Item autoComplete="off" label="Beneficiary LEI">
                        {getFieldDecorator("bene_lei", {
                            rules: validations.beneficiary_lei,
                        })(<Input autoComplete="off" prefix={<Icon type="idcard" />} />)}
                    </Form.Item>
                </div>}

                {isFtx && <>
                    <div className="col-sm-6">
                    <Form.Item autoComplete="off" label="Organisation Type">
                        {getFieldDecorator("organisation_type", {
                        rules: validations.organisation_type,
                        })(
                        <Select placeholder="Select Organisation Type">
                            {organisationTypes.map(({ label, value }) => (
                            <Select.Option key={value} value={value}>
                                {label}
                            </Select.Option>
                            ))}
                        </Select>
                        )}
                    </Form.Item>
                    </div>

                    <div className="col-sm-6">
                    <Form.Item autoComplete="off" label="Business Model">
                        {getFieldDecorator("business_model", {
                        rules: validations.business_model,
                        })(<Input autoComplete="off" prefix={<Icon type="idcard" />} />)}
                    </Form.Item>
                    </div>

                    <div className="col-sm-6">
                    <Form.Item autoComplete="off" label="CIN Number">
                        {getFieldDecorator("cin_number", {
                        rules: validations.cin_number,
                        })(<Input autoComplete="off" prefix={<Icon type="idcard" />} />)}
                    </Form.Item>
                    </div>

                    <div className="col-sm-6">
                    <Form.Item autoComplete="off" label="GST Number">
                        {getFieldDecorator("gst_number", {
                        rules: validations.gst_number,
                        })(<Input autoComplete="off" prefix={<Icon type="idcard" />} />)}
                    </Form.Item>
                    </div>
                </>}
            </div>

            {!props.current_user.itum &&
                <Button
                    className="pl-0 mb-2"
                    type="link"
                    onClick={() => setShowAdvancedOptions(!showAdvancedOptions)}
                >
                    {showAdvancedOptions ? "Hide Advanced Options" : "Show Advanced Options"}
                    <Icon type={showAdvancedOptions ? "down" : "right"} />
                </Button>}

            {showAdvancedOptions || props.current_user.itum ? (
                <div className="d-flex flex-wrap">
                    <Form.Item style={{ width: "30%" }} className="mr-2" label="UDF 1">
                        {getFieldDecorator("udf1", {
                            rules:
                                props.current_user.itum
                                    ? [
                                        ...validations.udf1,
                                        { required: true, message: "UDF1 is required" },
                                    ]
                                    : validations.udf1,
                        })(<Input autoComplete="off" prefix={<Icon type="form" />} />)}
                    </Form.Item>
                    <Form.Item style={{ width: "30%" }} className="mr-2" label="UDF 2">
                        {getFieldDecorator("udf2", {
                            rules:
                                props.current_user.itum
                                    ? [
                                        ...validations.udf2,
                                        { required: true, message: "UDF2 is required" },
                                    ]
                                    : validations.udf2,
                        })(<Input autoComplete="off" prefix={<Icon type="form" />} />)}
                    </Form.Item>
                    <Form.Item style={{ width: "30%" }} className="mr-2" label="UDF 3">
                        {getFieldDecorator("udf3", {
                            rules:
                                props.current_user.itum
                                    ? [
                                        ...validations.udf3,
                                        { required: true, message: "UDF3 is required" },
                                    ]
                                    : validations.udf3,
                        })(<Input autoComplete="off" prefix={<Icon type="form" />} />)}
                    </Form.Item>
                    <Form.Item style={{ width: "30%" }} className="mr-2" label="UDF 4">
                        {getFieldDecorator("udf4", {
                            rules:
                                props.current_user.itum
                                    ? [
                                        ...validations.udf4,
                                        { required: true, message: "UDF4 is required" },
                                    ]
                                    : validations.udf4,
                        })(<Input autoComplete="off" prefix={<Icon type="form" />} />)}
                    </Form.Item>
                    <Form.Item style={{ width: "30%" }} label="UDF 5">
                        {getFieldDecorator("udf5", {
                            rules:
                                props.current_user.itum
                                    ? [
                                        ...validations.udf5,
                                        { required: true, message: "UDF5 is required" },
                                    ]
                                    : validations.udf5,
                        })(<Input autoComplete="off" prefix={<Icon type="form" />} />)}
                    </Form.Item>
                </div>
            ) : null}

            <div className="w-100 d-flex justify-content-end mt-4">
                <Button type="primary" htmlType="submit" loading={props.loading}>{props.submitText}</Button>
            </div>
        </Form >
    )
};

const mapStateToProps = state => ({
    current_user: state.userReducer.current_user
});

QuickTransferForm = Form.create()(QuickTransferForm);

export default connect(mapStateToProps)(QuickTransferForm);